import React from "react";
import {Link} from "react-router";

class Employee extends React.Component {
  constructor() {
    super();
    this.state = {valid: 1, invalid: 0, form_error: ""};
    this.blur = this.blur.bind(this);
    this.login = this.login.bind(this);
  }

  login(event) {


    if (this.props.name == "Password") {
      if (event.key == 'Enter')
        this.props.clik();

    }

  }


  blur(e) {

    if (e.target.value.trim().length == 0) {

      let y = "Enter the " + this.props.name;
      this.setState({form_error: y});
    }
    else
      this.setState({form_error: ""});
    this.props.check();


  }

  render() {
    let style = {color: "#FFFFFF"};
    return (<div className={this.props.size}>
        <div className="form-group">
          <label htmlFor="employeeid">{this.props.name}</label>
          <input onBlur={this.blur} onKeyPress={this.login} type={this.props.type} className="form-control"
                 id={this.props.id} placeholder={this.props.placeholder} name={this.props.name}/>
          {this.state.form_error} <Link syle={style} to="/forgot" activeClassName="active">{this.props.href}</Link>
          <p>{this.props.er} </p>

        </div>
      </div>
    );

  }


}

Employee.propTypes = {
  size: React.PropTypes.string,
  placeholder: React.PropTypes.string,
  type: React.PropTypes.string,
  id: React.PropTypes.string,
  er: React.PropTypes.string,
  name: React.PropTypes.string,
  label: React.PropTypes.string,
  href: React.PropTypes.string,
  check: React.PropTypes.func

};

Employee.defaultProps = {
  size: "col-sm-4 col-md-5",
  placeholder: "Employee's Id",
  type: "text",
  id: "employeeid",
  er: "",
  name: "Employee Id",
  href: ""
};
export default Employee;



/** WEBPACK FOOTER **
 ** ./src/react/components/LoginField.js
 **/